import React, { useState, useEffect, useCallback } from 'react';
import cn from 'classnames';
import { Link, Icon } from '@landing/ui';
import BurgerBtn from './components/BurgerBtn';
import MobileMenu from './components/MobileMenu';
import AnchorMenu from './components/AnchorMenu';

import * as styles from './Header.module.scss';

export default function Header({ anchorLinks }) {
  const [headerFixed, setHeaderFixed] = useState(false);
  const [mobileMenuVisible, setActiveMobileMenu] = useState(false);

  const toggleMobileMenu = useCallback(() => {
    setActiveMobileMenu(!mobileMenuVisible);
  }, [mobileMenuVisible]);

  const handlerScroll = useCallback(() => {
    window.scrollY > 20 ? setHeaderFixed(true) : setHeaderFixed(false);
  }, []);

  const onLinkClick = useCallback(() => {
    setActiveMobileMenu(false);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handlerScroll, { passive: true });
    handlerScroll();

    return () => {
      window.removeEventListener('scroll', handlerScroll);
    };
  }, []);

  return (
    <header
      className={cn(styles.header, headerFixed && styles.fixed, mobileMenuVisible && styles.active)}
    >
      <div className={styles.layout}>
        <div className={styles.logos}>
          <Link href="https://andersenlab.com" className={styles.logoWrap}>
            <div className={styles.logo} />
          </Link>
          <Link href="https://www.connectglobalgroup.com/" className={styles.logoWrap}>
            {headerFixed || mobileMenuVisible ? (
              <Icon name="cgg-color" className={styles.secondLogo} />
            ) : (
              <Icon name="cgg-white" className={styles.secondLogo} />
            )}
          </Link>
        </div>
        <div className={styles.navigation}>
          <AnchorMenu theme={headerFixed && 'dark'} anchorLinks={anchorLinks} />
        </div>
        <div className={styles.touchPanel}>
          <BurgerBtn
            fixed={mobileMenuVisible}
            active={mobileMenuVisible}
            onClick={toggleMobileMenu}
            theme={headerFixed && 'dark'}
          />
          {mobileMenuVisible && <MobileMenu anchorLinks={anchorLinks} onLinkClick={onLinkClick} />}
        </div>
      </div>
    </header>
  );
}
